export const environment = {
  production: false,
  apiBaseUrl: 'https://api.assemblerai.io',
  workflowApiBaseUrl: 'https://agent.assemblerai.io',
  auth0: {
    domain: 'dev-mcwm6zoyingli70r.us.auth0.com',
    clientId: '3N3mtMIQdyOaTcA8ZUxFccV5gtHCEmga',
    audience: 'https://dev-mcwm6zoyingli70r.us.auth0.com/api/v2/',
  },
};

